import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d22a1b70&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d22a1b70&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22a1b70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d22a1b70')) {
      api.createRecord('d22a1b70', component.options)
    } else {
      api.reload('d22a1b70', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d22a1b70&scoped=true", function () {
      api.rerender('d22a1b70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/backup/index.vue"
export default component.exports